module.exports = __webpack_public_path__ + "media/customizations/lmhh/logo-8b1947051b234a903051a4a3189ab104.png";